export const returnStyle = (styles) => {
  let returnStyle = {};
  Array.isArray(styles)
    ? styles.map((item) => {
        returnStyle = { ...returnStyle, ...item };
      })
    : (returnStyle = styles);
  return returnStyle;
};
